export default __webpack_public_path__ + "static/media/martinize_elastic2.93e2ba15.png";